<div class="loading-container" [class.overlay]="overlay">
  <mat-progress-spinner [diameter]="diameter" mode="indeterminate"></mat-progress-spinner>
  <p *ngIf="message" class="loading-message">{{ message }}</p>
</div>

